var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibility = function SvgAccessibility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.847 10.605a6 6 0 1 0-7.694 0 5 5 0 0 0-.355.395H4a1.5 1.5 0 0 0 0 3h6.599L9.443 24.327l-.722 5.993a1.5 1.5 0 1 0 2.978.36l.564-4.68h7.474l.564 4.68a1.5 1.5 0 1 0 2.978-.36l-.722-5.993L21.4 14H28a1.5 1.5 0 0 0 0-3h-7.798a5 5 0 0 0-.355-.395M19 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-.601 8.145.99 8.855H12.61l.991-8.855a2.414 2.414 0 0 1 4.798 0",
    clipRule: "evenodd"
  })));
};
export default SvgAccessibility;